<template>
  <a-modal :title="title" :visible.sync="dialogVisible" width="50%">
    <pre>{{message}}</pre>
  </a-modal>
</template>
<script>
import { bus } from "@/bus.js";
export default {
  data() {
    return {
      dialogVisible: false,
      title: "",
      message: ""
    };
  },
  created() {
    let that = this;
    bus.$on("dialog", function(message, title) {
      that.message = message;
      that.title = title;
      that.dialogVisible = true;
    });
  },
  methods: {
    handleClose(done) {
      this.$confirm("Are you sure to close this dialog?")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    }
  }
};
</script>
<style scoped>
pre {
  background: #22313f;
  border-radius: 0.3em;
  box-sizing: border-box;
  color: #f8f8f2;
  margin: 1.6em 0;
  overflow: auto;
  padding: 10px;
  width: 100%;
  white-space: pre-wrap;
}
</style>


// WEBPACK FOOTER //
// src/components/internal/TextAreaDialog.vue